var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7000_2042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.456 11.4552C20.6673 11.2541 20.9485 11.1428 21.2402 11.1451C21.5319 11.1473 21.8114 11.2627 22.0196 11.4671C22.2279 11.6714 22.3486 11.9486 22.3563 12.2403C22.364 12.5319 22.2581 12.8152 22.061 13.0302L16.076 20.5152C15.9731 20.6261 15.8488 20.715 15.7108 20.7768C15.5727 20.8385 15.4236 20.8718 15.2723 20.8746C15.1211 20.8774 14.9709 20.8497 14.8306 20.7931C14.6903 20.7365 14.5629 20.6522 14.456 20.5452L10.487 16.5762C10.3764 16.4732 10.2878 16.349 10.2263 16.211C10.1648 16.073 10.1317 15.9241 10.1291 15.773C10.1264 15.622 10.1542 15.4719 10.2108 15.3318C10.2674 15.1917 10.3516 15.0645 10.4584 14.9577C10.5652 14.8508 10.6925 14.7666 10.8326 14.71C10.9727 14.6535 11.1227 14.6257 11.2738 14.6283C11.4248 14.631 11.5738 14.6641 11.7118 14.7256C11.8498 14.787 11.974 14.8757 12.077 14.9862L15.218 18.1257L20.4275 11.4882C20.4368 11.4767 20.4469 11.4657 20.4575 11.4552H20.456Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7000_2042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilled);
export default __webpack_public_path__ + "static/media/check-filled.f10291ffbd5fc9bb883316ecafa1811f.svg";
export { ForwardRef as ReactComponent };